import { render, staticRenderFns } from "./ModeratorCurrentMonthTab.vue?vue&type=template&id=dba29bf2&"
import script from "./ModeratorCurrentMonthTab.vue?vue&type=script&lang=js&"
export * from "./ModeratorCurrentMonthTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports